// Redux slice for the Access (ZS users) page. Loads the allowlist from the live
// backend; fails loudly (no mock fallback) with an error state + Retry.

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { IAccessUser } from "../models/interfaces";
import { getUsers } from "../serviceHelper";

interface AccessState {
	users: IAccessUser[];
	search: string;
	isLoading: boolean;
	error: string | null;
}

export const initialState: AccessState = {
	users: [],
	search: "",
	isLoading: false,
	error: null,
};

export const fetchUsers = createAsyncThunk("access/fetchUsers", async () => {
	return await getUsers();
});

const accessSlice = createSlice({
	name: "accessSlice",
	initialState,
	reducers: {
		setUserSearch: (state, action: PayloadAction<string>) => {
			state.search = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchUsers.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(fetchUsers.fulfilled, (state, action) => {
				state.isLoading = false;
				state.error = null;
				state.users = action.payload;
			})
			.addCase(fetchUsers.rejected, (state, action) => {
				state.isLoading = false;
				state.users = [];
				state.error = action.error.message ?? "Failed to load users";
			});
	},
});

export const { setUserSearch } = accessSlice.actions;
export default accessSlice.reducer;
